import React from "react";

const ChevronDown = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path
      stroke="currentColor"
      d="M1 8l11 8 11-8"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDown;



// WEBPACK FOOTER //
// ./src/theme/icons/ChevronDown.js